import { ChipTypeMap } from "@mui/material";
import Autocomplete, { AutocompleteProps } from "@mui/material/Autocomplete";
import { forwardRef, useRef } from "react";

const MDInput = require("components/MDInput/index.js").default;


export default function AloveAutocomplete<
  Value,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
  ChipComponent extends React.ElementType = ChipTypeMap['defaultComponent'],
>(
  props: AutocompleteProps<Value, Multiple, DisableClearable, FreeSolo, ChipComponent>,
): JSX.Element {
    const {renderInput, onChange, ...rest} = props;
    const inputRef = useRef<HTMLInputElement>(null);

  return (
    <Autocomplete
      renderInput={(params) => <MDInput {...params} label="Category" inputRef={inputRef} />}
      onChange={(event, value, details, reason) => {
        onChange?.(event, value, details, reason);
        inputRef.current?.blur();
      }}

      {...rest}
    />
  );
}